var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-cpanel"},[_vm._m(0),_c('section',{staticClass:"contenedor-c"},[_c('Samyoga2025Lista')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-titulo"},[_c('h1',[_vm._v("Inscripciones Samyoga 2025")]),_c('div',{staticClass:"barra"})])
}]

export { render, staticRenderFns }